// =============================================================================
// File: frontend/src/components/BetaBadge.jsx
// #83 — small "BETA" recognition pill shown next to the user's plan in the SBM
// footer when user.is_beta. Self-contained (inline D4S navy/gold styling — no CSS
// file changes, no layout dependency). Renders nothing for non-beta users.
// =============================================================================

import React from 'react';

function BetaBadge({ user, style }) {
  if (!user?.is_beta) return null;
  return (
    <span
      title="You're a Healist founding beta tester"
      style={{
        display: 'inline-block',
        marginLeft: 6,
        padding: '1px 7px',
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: '0.06em',
        lineHeight: 1.6,
        borderRadius: 999,
        color: '#0b1f3a',
        background: 'linear-gradient(135deg, #e9c46a, #d4a843)',
        verticalAlign: 'middle',
        ...style,
      }}
    >
      BETA
    </span>
  );
}

export default BetaBadge;
